<template>
  <div class="this-content">
    <div class="this-main" :style="isShowMore ? 'border-bottom:1px solid #F3F3F3' : ''">
      <div class="h-search-box">
        <i class="el-icon-hb-shaixuan" style="font-size: 15px;" v-show="hasMore"></i>
        <el-button class="search-tip" type="text" size="mini" @click="showMoreChanage" v-if="searchConfig && searchConfig.length > 0 && hasMore">
          {{ isShowMore ? '收起条件' : '筛选条件' }}
        </el-button>

        <i :class="isShowMore ? 'el-icon-hb-jiantou4' : 'el-icon-hb-jiantou5'" style="font-size: 10px;margin-right: 40px;" v-show="hasMore"></i>
        <template v-for="(item, index) in searchConfig">
          <!-- 下拉选 -->
          <el-select class="mr-10" v-if="item.type == 'select' && item.hasBase" :style="item.width ? 'width:' + item.width + 'px;' : 'width:200px;'" v-model="item.value" :key="index" :placeholder="item.placeholder ? item.placeholder : '请选择'" clearable>
            <el-option :label="item.labelKey?item2[item.labelKey]:item2.label" :value="item.valueKey?item2[item.valueKey]:item2.value" v-for="(item2, index2) in item.options" :key="index2"></el-option>
          </el-select>
          <!-- 下拉选 级联 -->
          <el-cascader class="mr-10" clearable v-if="item.type == 'cascader' && item.hasBase" v-model="item.value" :placeholder="item.placeholder ? item.placeholder : '请选择'" :options="item.options" :key="index" :props="propsFormat(item)"></el-cascader>
          <!-- 日期 -->

          <el-date-picker class="mr-10" v-if="item.type == 'datePicker' && item.hasBase" :style="!item.width ? 'width: 380px;' : 'width:' + item.width + 'px'" :value-format="datePickerValueFormat(item.pickerType)" v-model="item.value" :key="index" :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始时间'" :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束时间'" :type="item.pickerType == undefined ? 'daterange' : item.pickerType" :picker-options="item.pickerOptions ? pickerOptions : ''" range-separator="至"></el-date-picker>
          <!-- 关键字 -->
          <el-input class="mr-10" v-if="item.type == 'keywords'&&item.hasBase" :style="item.width ? 'width:' + item.width + 'px;' : 'width:200px;'" v-model="item.value" :key="index" :placeholder="item.placeholder ? item.placeholder : '请输入关键字'" clearable></el-input>
        </template>
        <el-button type="primary" size="medium" style="margin-left:10px" @click="search" v-if="searchConfig && searchConfig.length > 0">搜索</el-button>
        <el-button type="info" size="medium" style="margin: 20px" @click="reset" v-if="searchConfig && searchConfig.length > 0">重置</el-button>
        <div class="handle-box">
          <slot></slot>
        </div>
      </div>
    </div>
    <!-- 更多 -->
    <div class="search-more-box" v-show="isShowMore">
      <div class="search-more">
        <template v-for="(item, index) in searchConfig">
          <!-- 下拉选 -->
          <el-select class="ml-20 mr-10 mb-20 mt-10" v-if="item.type == 'select' && !item.hasBase" :style="item.width ? 'width:' + item.width + 'px;' : 'width:200px;'" v-model="item.value" :key="index" :placeholder="item.placeholder ? item.placeholder : '请选择'">
            <el-option :label="item2.label" :value="item2.value" v-for="(item2, index2) in item.options" :key="index2"></el-option>
          </el-select>
          <!-- 下拉选 级联 -->
          <el-cascader class="ml-20 mr-10 mb-20 mt-10" clearable v-if="item.type == 'cascader' && !item.hasBase" :style="item.width ? 'width:' + item.width + 'px;' : 'width:200px;'" v-model="item.value" :placeholder="item.placeholder ? item.placeholder : '请选择'" :options="item.options" :key="index"></el-cascader>
          <!-- 日期 -->
          <el-date-picker class="ml-20 mr-10 mb-20 mt-10" value-format="yyyy-MM-dd" v-if="item.type == 'datePicker' && !item.hasBase" :style="!item.width ? 'width: 380px;' : 'width:' + item.width + 'px'" v-model="item.value" :key="index" :start-placeholder="item.startPlaceholder ? item.startPlaceholder : '开始时间'" :end-placeholder="item.endPlaceholder ? item.endPlaceholder : '结束时间'" :type="item.pickerType == undefined ? 'daterange' : item.pickerType" :picker-options="item.pickerOptions ? pickerOptions : ''" range-separator="至"></el-date-picker>
          <!-- 关键字 -->
          <el-input class="mr-10 mt-10" v-if="item.type == 'keywords'&& !item.hasBase" :style="item.width ? 'width:' + item.width + 'px;' : 'width:200px;'" v-model="item.value" :key="index" :placeholder="item.placeholder ? item.placeholder : '请输入关键字'" clearable></el-input>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowMore: false,
      searchConfig: '',
      hasMore: false,
    }
  },
  props: ['config', 'optConfig', 'handleOpt', 'doSearch'],
  mounted() {
    // 初始化
    this.init()
  },
  watch: {},
  methods: {
    init() {
      let that = this
      if (this.config) {
        this.searchConfig = JSON.parse(JSON.stringify(this.config))
        for (let i = 0; i < this.searchConfig.length; i++) {
          // console.log(this.searchConfig[i], '配置')
          if (this.searchConfig[i].type == 'select' && this.searchConfig[i].api) {
            //下拉选
            this.byApiGetList(i, this.searchConfig[i].api)
          } else if (this.searchConfig[i].type == 'cascader' && this.searchConfig[i].api) {
            console.log(this.searchConfig[i], '配置')
            //级联
            this.byApiGetList2(i, this.searchConfig[i].api, [], 0)
          } else if (this.searchConfig[i].type == 'datePicker') {
            //日期
            this.searchConfig[i].value = []
          }
          if (!this.searchConfig[i].hasBase) {
            this.hasMore = true
          }
        }
      }
    },
    propsFormat(item) {
      let p = item.props || {}
      p.checkStrictly = item.checkStrictly
      return p
    },
    showMoreChanage() {
      this.isShowMore = !this.isShowMore
    },
    //根据api获取数据 下拉选查询数据,处理数据
    byApiGetList(index, _api) {
      let that = this
      let data = {}
      this.$API[_api](data).then((res) => {
        let list = res
        for (let i = 0; i < list.length; i++) {
          if (that.searchConfig[index].labelKey) {
            list[i].label = list[i][that.searchConfig[index].labelKey]
          } else {
            list[i].label = list[i].name
          }
          if (that.searchConfig[index].valueKey) {
            list[i].value = list[i][that.searchConfig[index].valueKey]
          } else {
            list[i].value = list[i].value
          }
        }
        that.searchConfig[index].options = list
      })
    },
    //根据api获取数据  级联下拉选查询数据,处理数据
    byApiGetList2(index, _apis, lists, i) {
      let that = this
      let data = {}
      this.$API[_apis[i]](data).then((res) => {
        let list = res
        for (let j = 0; j < list.length; j++) {
          if (that.searchConfig[index].labelKey[i]) {
            list[j].label = list[j][that.searchConfig[index].labelKey[i]]
          } else {
            list[j].label = list[j].name
          }
          if (that.searchConfig[index].valueKey[i]) {
            list[j].value = list[j][that.searchConfig[index].valueKey[i]]
          } else {
            list[j].value = list[j].value
          }
        }
        if (i == 0) {
          lists = list
        } else {
          for (let j = 0; j < lists.length; j++) {
            lists[j].children = []
            for (let k = 0; k < list.length; k++) {
              if (lists[j][that.searchConfig[index].linkage[0]] == list[k][that.searchConfig[index].linkage[1]]) {
                lists[j].children.push(list[k])
              }
            }
          }
        }
        if (i + 1 < _apis.length) {
          that.byApiGetList2(index, _apis, lists, i + 1)
        } else {
          that.searchConfig[index].options = lists
        }
      })
    },

    search() {
      // console.log('this.searchConfig', this.searchConfig);
      let list = {}
      for (let i = 0; i < this.searchConfig.length; i++) {
        if (this.searchConfig[i].value) {
          if (this.searchConfig[i].type == 'cascader') {
            for (let j = 0; j < this.searchConfig[i].value.length; j++) {
              if (typeof this.searchConfig[i].field == 'string') {
                if (j == this.searchConfig[i].value.length - 1) {
                  list[this.searchConfig[i].field] = this.searchConfig[i].value[j]
                }
              } else {
                list[this.searchConfig[i].field[j]] = this.searchConfig[i].value[j]
              }
            }
          } else if (this.searchConfig[i].type == 'select') {
            list[this.searchConfig[i].field] = this.searchConfig[i].value
          } else if (this.searchConfig[i].type == 'keywords') {
            list[this.searchConfig[i].field] = this.searchConfig[i].value
          } else if (this.searchConfig[i].type == 'datePicker') {
            if (this.searchConfig[i].pickerType == 'daterange' || !this.searchConfig[i].pickerType) {
              if (this.searchConfig[i].value[0] != undefined) {
                list[this.searchConfig[i].field[0]] = this.searchConfig[i].value[0]
                // list[this.searchConfig[i].field[0]] = this.searchConfig[i].value[0] + ' 00:00:00'
              }
              if (this.searchConfig[i].value[1] != undefined) {
                list[this.searchConfig[i].field[1]] = this.searchConfig[i].value[1]
                // list[this.searchConfig[i].field[1]] = this.searchConfig[i].value[1] + ' 23:59:59'
              }
            } else {
              list[this.searchConfig[i].field] = this.searchConfig[i].value
            }
          }
        }
      }
      console.log('98+8+8', list)
      this.doSearch(list)
    },
    reset() {
      for (let i = 0; i < this.searchConfig.length; i++) {
        if (this.searchConfig[i].type == 'cascader') {
          this.searchConfig[i].value = []
        } else if (this.searchConfig[i].type == 'select') {
          this.searchConfig[i].value = ''
        } else if (this.searchConfig[i].type == 'keywords') {
          this.searchConfig[i].value = ''
        } else if (this.searchConfig[i].type == 'datePicker') {
          this.searchConfig[i].value = ''
        }
      }
      this.doSearch({})
    },
    datePickerValueFormat(type) {
      if (type == 'daterange') {
        return 'yyyy-MM-dd'
      } else if (type == 'month') {
        return 'yyyy-MM'
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped>
.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-20 {
  margin-right: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-10 {
  margin-top: 10px;
}
.this-content {
  width: inherit;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  /* box-shadow: 0px -3px 13px 0px rgba(142, 148, 179, 0.17); */
  /* margin-bottom: 20px; */
  flex-shrink: 0;
}
.this-main {
  min-height: 88px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
}
.search-tip {
  margin: 0 10px;
  font-size: 15px;
  color: #222738;
}
.h-search-box {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 22px;
  flex-wrap: wrap;
}
.h-opt-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  /* width: 300px; */
  height: 100%;
}
.h-opt-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 40px;
  font-size: 16px;
  color: #2b2f3f;
  font-family: Microsoft YaHei;
  cursor: pointer;
}
.h-opt-btn img {
  height: 43px;
  width: 43px;
  margin-right: 10px;
  /* border-radius: 50%; */
}
.search-more-box {
  display: flex;
  flex-direction: column;
}
.search-more {
  height: auto;
  min-height: 88px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  /* padding: 20px 10px 0 0; */
  flex-wrap: wrap;
}
.handle-box {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 100%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/hbSearch.vue